// App.tsx
import React, { useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import { AuthProvider } from "./context/auth-context";
import { ThemeProvider } from "./context/ThemeContext";
import "leaflet/dist/leaflet.css";
import { TabGuard } from "./utils/tabGuard";
import MainLayout from "./MainLayout";

const App: React.FC = () => {
  const [tabAllowed, setTabAllowed] = useState<boolean | null>(null);
  const [tabGuard] = useState(() => new TabGuard());

  useEffect(() => {
    tabGuard.init((allowed) => {
      setTabAllowed(allowed);
    });

    return () => {
      tabGuard.release();
    };
  }, [tabGuard]);

  if (tabAllowed === null) {
    return null;
  }

  if (tabAllowed === false) {
    return (
      <div
        style={{
          minHeight: "100vh",
          width: "100%",
          background: "#124280",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 16,
          boxSizing: "border-box",
        }}
      >
        <div
          style={{
            maxWidth: 480,
            width: "100%",
            background: "#fff",
            borderRadius: 12,
            padding: "32px 24px",
            fontFamily: "Poppins, sans-serif",
            boxSizing: "border-box",
            textAlign: "center",
          }}
        >
          <h1
            style={{
              fontSize: 22,
              marginBottom: 12,
              color: "#124280",
              fontWeight: 600,
            }}
          >
            Aba já ativa
          </h1>
          <p
            style={{
              fontSize: 14,
              marginBottom: 24,
              color: "#333",
              lineHeight: 1.5,
            }}
          >
            Você já está com o sistema EVA aberto em outra aba ou janela deste
            navegador.
            <br />
            Feche as outras abas com o sistema aberto para continuar.
          </p>
          <button
            onClick={() => {
              window.location.reload();
            }}
            style={{
              width: "100%",
              height: 46,
              borderRadius: 8,
              border: "none",
              background: "#124280",
              color: "#fff",
              fontSize: 16,
              fontWeight: 500,
              cursor: "pointer",
            }}
          >
            Tentar novamente
          </button>
        </div>
      </div>
    );
  }

  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <MainLayout>
            <AppRoutes />
          </MainLayout>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
};

export default App;
